export default "__VITE_ASSET__CH5am1qX__ 960w, __VITE_ASSET__Bb8j5iJ1__ 1420w";